import { GET_BULK_CHALLAN } from "../types";

const initalState = {
    bulkChallan: []
};

export default function (state = initalState, action) {
    const { payload, type } = action;
    switch (type) {
        case GET_BULK_CHALLAN:
            return { ...state, bulkChallan: payload?.response }

        default:
            return state;
    }
}